"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.JcbFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var JcbFilled = function JcbFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 3,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.078 13.929v-1.583h1.732a.87.87 0 01.215.017.8.8 0 01.61.774c0 .412-.28.71-.61.775-.05 0-.165.017-.215.017h-1.732zM25.612 3H30v14.983c0 1.665-1.353 3-3.002 3h-4.404v-6.098h4.651c1.089 0 1.914-.594 1.914-1.5 0-.841-.743-1.385-1.716-1.45V11.9c.891-.115 1.37-.692 1.37-1.368 0-.857-.71-1.352-1.667-1.401-.082-.017-.198-.017-.297-.017H22.61V6c0-1.665 1.353-3 3.002-3zm.809 7.73c0 .396-.28.66-.61.71-.017.016-.116.016-.166.016h-1.567v-1.45h1.567c.05 0 .132.016.165.016.33.05.61.313.61.709z",
    fill: "url(#JCBFilled_svg__JCBFilled_svg__paint0_linear_19_1905)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.316 3a3.001 3.001 0 00-3.002 3v3.923c.758-.643 2.078-1.055 4.206-.956 1.138.05 2.358.363 2.358.363v1.269c-.61-.313-1.336-.594-2.276-.66-1.616-.115-2.59.676-2.59 2.061 0 1.401.974 2.192 2.59 2.06.94-.066 1.666-.362 2.276-.659v1.27s-1.204.313-2.358.362c-2.128.099-3.448-.313-4.207-.956V21h4.405a3.001 3.001 0 003.002-3V3h-4.404z",
    fill: "url(#JCBFilled_svg__JCBFilled_svg__paint1_linear_19_1905)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.019 3a3.001 3.001 0 00-3.003 3v7.401c.842.412 1.716.676 2.59.676 1.04 0 1.6-.626 1.6-1.484V9.1h2.573v3.478c0 1.352-.84 2.456-3.694 2.456-1.732 0-3.085-.38-3.085-.38v6.314h4.404a3.001 3.001 0 003.002-3V3H9.02z",
    fill: "url(#JCBFilled_svg__JCBFilled_svg__paint2_linear_19_1905)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCBFilled_svg__JCBFilled_svg__paint0_linear_19_1905",
    x1: 22.607,
    y1: 20.985,
    x2: 30.02,
    y2: 20.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCBFilled_svg__JCBFilled_svg__paint1_linear_19_1905",
    x1: 14.271,
    y1: 20.868,
    x2: 21.581,
    y2: 20.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCBFilled_svg__JCBFilled_svg__paint2_linear_19_1905",
    x1: 6.013,
    y1: 21.115,
    x2: 13.54,
    y2: 21.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  }))));
};

exports.JcbFilled = JcbFilled;
var _default = JcbFilled;
exports.default = _default;